export enum SubscriptionDomainEnum {
  SUBSCRIPTION = 'subscriptions',
  HISTORY = 'history',
  MANAGE = 'manage',
}

export enum SubscriptionsIds {
  Premium = 27,
  Standart = 24,
}
